import {Directive, ElementRef} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[emsAlphaNumericPatterncheck]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: AlphaNumericPatterncheckDirective, multi: true}
  ]
})
export class AlphaNumericPatterncheckDirective {

  newExp: any;

  constructor(public el: ElementRef) {
  }

  validate() {
    this.newExp = new RegExp('^[a-zA-Z0-9]*$');
    const elementVal = this.el.nativeElement.value;
    if (this.newExp.test(elementVal)) {
      return null;
    } else {
      return {
        emsAlphaNumericPattern: false
      };
    }
  }
}
